import {
  LNC_ESPACE,
  LncMonCompteClientService,
} from '@odw/lnc-services/js-services/api-client/lnc-mon-compte-client.service';
import { huitabSettings } from '../../services/settings-loader';
import CartoDelestageService from './carto-delestage.service';
import MesAutorisationsCollocService from './mes-autorisations-colloc.service';
import MesCollectivitesService from './mes-collectivites.service';
import MesSddEntreprise from './mes-sdd-entreprise';
import MesTachesApiClientService from './mes-taches.api.client.service';
import MesTravauxCollocService from './mes-travaux-colloc.service';
import PassageHiverService from './passage-hiver.service';
import MesPrmsOrgaService from './mes-prms-orga.service'

const monCompteClientService = new LncMonCompteClientService(
  huitabSettings.url.mon_compte_client_api_url,
  LNC_ESPACE.COLLECTIVITE,
);
const mesCollectivitesService = new MesCollectivitesService(huitabSettings.url.mes_collectivites_api_url);
const mesTravauxApiService = new MesTravauxCollocService(huitabSettings.url.mes_travaux_colloc_api_url);
const passageHiverService = new PassageHiverService(huitabSettings.url.mes_collectivites_api_url);
const mesAutorisationsCollocService = new MesAutorisationsCollocService(
  huitabSettings.url.mes_autorisations_colloc_api_url,
);
const mesTachesService = new MesTachesApiClientService(huitabSettings.url.mes_taches_api_url);
const mesPrmsOrgaService = new MesPrmsOrgaService(huitabSettings.url.mes_prms_orga_api_url);
const cartoDelestageService = new CartoDelestageService(huitabSettings.url.carto_delestage_api_url);
const mesSddEntrepriseService = new MesSddEntreprise(huitabSettings.url.mes_sdd_entreprise_api_url);
export {
  cartoDelestageService,
  mesAutorisationsCollocService,
  mesCollectivitesService,
  mesPrmsOrgaService,
  mesSddEntrepriseService,
  mesTachesService,
  mesTravauxApiService,
  monCompteClientService,
  passageHiverService,
};
